<script>
    import { AddCircle } from '../Icons'
    import {
        Alert,
        BackDrop,
        TertiaryButton,
        Typography,
        InputTable,
    } from '../UI'
    import SucursalWidget from '$lib/custom/components/SucursalWidget.svelte'
    import dictionaries from '$lib/stores/dictionaries'
    import {ENV} from '$lib/conf'

    export let data = {}
    export let valid = false
    let visible = false
    let sucursales = data?.sucursales || []
    function onClose() {
        visible = false
    }
    function onSave({ detail: { data: ret } }) {
        sucursales = [...sucursales, ret]
        visible = false
    }
    const schema = {
        nombre: {},
        calle: {},
        numero: { label: 'Número' },
        jurisdiccion: {
            label: 'Jurisdicción',
            render: (n) =>
                $dictionaries.vprovincias.find((x) => x.value == n)?.label,
        },
        localidad: {},
    }
    $: data.sucursales = sucursales
    $: valid = sucursales?.length > 0
</script>

<div class="container">
    <span>
        <Typography type="body" color="grey-800"
            >Complete la siguiente tabla con las sucursales desde las que provea
            a {ENV.COMPANY_NAME}.</Typography
        >
        <InputTable {schema} autoform={false} bind:value={sucursales} />
    </span>
    <TertiaryButton icon={AddCircle} on:click={() => (visible = true)}
        >Agregar sucursal</TertiaryButton
    >
    {#if !valid}
        <Alert type="error">Agregue al menos una sucursal</Alert>
    {:else}
        <Alert type="info"
            >Recuerda que puedes agregar, modificar y eliminar las sucursales
            desde la plataforma en cualquier momento.</Alert
        >
    {/if}
</div>
<BackDrop {visible} style="position: fixed;">
    <SucursalWidget
        title="Agregar una sucursal"
        subtitle="A continucion ubique su sucursal en el mapa, luego complete y verifique sus datos"
        on:close={onClose}
        on:save={onSave}
    />
</BackDrop>

<style>
    .container {
        display: flex;
        flex-direction: column;
        gap: 25px;
    }
</style>
